// Same as the backend's default optionTrade.multiplier.
export const OPTION_MULTIPLIER = 100;

export const formatMoney = (value) =>
  (value || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const tradeMultiplier = (trade) =>
  trade?.optionTrade?.multiplier || OPTION_MULTIPLIER;
